module.exports = __webpack_public_path__ + "static/media/premium_resume_button.8b93473f.webp";